import type { Updater } from '@tanstack/vue-table'
import type { Ref } from 'vue'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Email validation regex pattern
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const COMMON_EMAIL_DOMAIN_TYPOS: Record<string, string> = {
  "g-m-i-a-l.com": "gmail.com",
  "g-mail.com": "gmail.com",
  "gail.com": "gmail.com",
  "gamil.com": "gmail.com",
  "gmai.com": "gmail.com",
  "gmail.co": "gmail.com",
  "gmail.cmo": "gmail.com",
  "gmail.cm": "gmail.com",
  "gmail.con": "gmail.com",
  "gmail.ocm": "gmail.com",
  "gmail.om": "gmail.com",
  "gmaill.com": "gmail.com",
  "gmal.com": "gmail.com",
  "gmali.com": "gmail.com",
  "gmial.com": "gmail.com",
  "gnail.com": "gmail.com",
  "hotmai.com": "hotmail.com",
  "hotmail.co": "hotmail.com",
  "hotmail.cm": "hotmail.com",
  "hotmail.con": "hotmail.com",
  "hotmail.om": "hotmail.com",
  "hotmial.com": "hotmail.com",
  "icloud.co": "icloud.com",
  "icloud.cm": "icloud.com",
  "icloud.con": "icloud.com",
  "icloud.om": "icloud.com",
  "outllok.com": "outlook.com",
  "outlok.com": "outlook.com",
  "outlook.co": "outlook.com",
  "outlook.cm": "outlook.com",
  "outlook.con": "outlook.com",
  "outlook.om": "outlook.com",
  "yaho.com": "yahoo.com",
  "yahoo.co": "yahoo.com",
  "yahoo.cm": "yahoo.com",
  "yahoo.con": "yahoo.com",
  "yahoo.om": "yahoo.com",
};

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

export function getEmailDomainTypoSuggestion(email: string): string | null {
  const atIndex = email.lastIndexOf("@");
  if (atIndex === -1) {
    return null;
  }
  const domain = email.slice(atIndex + 1).trim().toLowerCase();
  return COMMON_EMAIL_DOMAIN_TYPOS[domain] ?? null;
}

export function valueUpdater<T extends Updater<any>>(updaterOrValue: T, ref: Ref) {
  ref.value
    = typeof updaterOrValue === 'function'
      ? updaterOrValue(ref.value)
      : updaterOrValue
}
